import { AvailabilityResponse } from '../../../../../../../api/types/calender/avalability-slots/availability-response';
import { AvailabilitySlot } from '../../../../../../../api/types/calender/avalability-slots/availability-slot';

export const selectSlotOperation = (
  res: AvailabilityResponse[],
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  },
  handleSlotSelect: (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => any,
) => {
  res.forEach((classSlotsItem) => {
    if (classSlotsItem.classId === editTimeSlot.classId) {
      //classSlotItem.slots[0].isAvailable = true;
      const targetSlot = classSlotsItem.slots.find(
        (item) =>
          new Date(item.startTime).getTime() >=
            new Date(editTimeSlot.start).getTime() &&
          new Date(item.endTime).getTime() <=
            new Date(editTimeSlot.end).getTime(),
      );
      if (targetSlot) {
        targetSlot.isAvailable = true;
      }
    }
  });

  const slotsMap = res.flatMap((item) =>
    item.slots.map((slotItem) => ({
      classId: item.classId,
      startTime: slotItem.startTime,
      endTime: slotItem.endTime,
    })),
  );
  const slotToSelect = slotsMap.find(
    (item) => item.classId === editTimeSlot.classId,
  );
  if (slotToSelect) {
    const selectSlot = {
      classId: slotToSelect.classId,
      startTime: new Date(slotToSelect.startTime),
      endTime: new Date(slotToSelect.endTime),
      isAvailable: true,
    };
    console.log(
      `onApproveAddNewSchedule selectedSlot 2: ${JSON.stringify(selectSlot)}`,
    );
    handleSlotSelect(0, selectSlot);
  }
};
